export enum VisualizationDataViewEnum {
  TABLE = 'TABLE',
  BAR_GRAPH = 'BAR_GRAPH',
  LINE_GRAPH = 'LINE_GRAPH',
}
